export function getLabelClickEventName(id) {
  return `clickALabel_${ id }`;
}
